export const desktop = 1200;
export const laptop = 1200;
export const laptopS = 1024;
export const tabletS = 920;
export const tablet = 768;
export const mobileXL = 680;
export const mobileL = 480;
export const mobileML = 425;
export const mobileM = 375;
export const mobileS = 320;
export const mobileXS = 280;
export const xs = 0;

export const breakpoints = {
  desktop,
  laptop,
  laptopS,
  tabletS,
  tablet,
  mobileXL,
  mobileL,
  mobileML,
  mobileM,
  mobileS,
  mobileXS,
  xs,
};
